<template>
    <div class="col-lg-12 mx-2">
        <ContentContainer>
            <template v-slot:content>
                <div class="w-50 mx-auto">
                    <form @submit.prevent="handleSubmit">
                        <div class="my-2">
                            <material-input id="password" type="password" v-model="password"
                                label="Enter your new password" name="password" :isRequired="true" />
                        </div>
                        <div class="my-2">
                            <material-input id="confirm-password" type="password" v-model="confirm_password"
                                label="Retype your password" name="confirmPassword" :isRequired="true" />
                        </div>
                        <div class="mb-4">
                            <p class="text-secondary">*Password must be atleast 6 characters.</p>
                        </div>
                        <div class="">
                            <p style="font-size: 12px; color: red; text-align: center;">{{ error }}</p>
                        </div>
                        <div class="">
                            <material-button class="mb-2 py-2" size="sm" variant="gradient" color="success"
                                fullWidth>Change
                                Password</material-button>
                        </div>
                    </form>
                </div>
            </template>
        </ContentContainer>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';
import ContentContainer from '@/components/PageLayout/ContentContainer.vue';
import MaterialInput from "@/components/common/MaterialInput.vue";
import MaterialButton from "@/components/common/MaterialButton.vue";
import LoggerService from "@/services/LoggerService";

const store = useStore();
const toast = useToast();

// Reactive state
const password = ref("");
const confirm_password = ref("");
const error = ref("");

// Computed
const stChangePasswordResponse = computed(() => store.getters.stChangePasswordResponse);
const stSessionData = computed(() => store.getters.stSessionData);

// Methods
const handleSubmit = async () => {
    error.value = "";
    if (password.value.length < 6) {
        error.value = "Password must be atleast 6 characters";
        return;
    }
    if (password.value !== confirm_password.value) {
        error.value = "Password not matching";
        return;
    }

    try {
        await store.dispatch('changePassword', password.value);
        
        // Log password change
        LoggerService.logDataOperation(
            'PASSWORD_CHANGE',
            'user',
            stSessionData.value?.personId,
            { action: 'Password changed successfully' },
            stSessionData.value?.personId
        );
        
        toast.success(stChangePasswordResponse.value.message, {
            position: 'top-right',
        });
        password.value = '';
        confirm_password.value = '';
    } catch (err) {
        console.error('Error changing password:', err);
        // Log failed password change attempt
        LoggerService.logDataOperation(
            'PASSWORD_CHANGE_FAILED',
            'user',
            stSessionData.value?.personId,
            { error: err.message },
            stSessionData.value?.personId
        );
    }
};
</script>
